import React from 'react';
import './ViewToggle.css';

const ViewToggle = ({ currentView, onViewChange }) => {
  return (
    <div className="view-toggle-container">
      <button
        className={`view-toggle-btn ${currentView === 'all-staff' ? 'active' : ''}`}
        onClick={() => onViewChange('all-staff')}
        title="All Staff View"
      >
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
          <rect x="2" y="3" width="16" height="3" fill="currentColor"/>
          <rect x="2" y="8" width="16" height="3" fill="currentColor"/>
          <rect x="2" y="13" width="16" height="3" fill="currentColor"/>
        </svg>
        <span>All Staff</span>
      </button>
      
      <button
        className={`view-toggle-btn ${currentView === 'pic-tracker' ? 'active' : ''}`}
        onClick={() => onViewChange('pic-tracker')}
        title="PIC Tracker View"
      >
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
          <rect x="2" y="2" width="7" height="5" stroke="currentColor" strokeWidth="1.5" fill="none"/>
          <rect x="11" y="2" width="7" height="5" stroke="currentColor" strokeWidth="1.5" fill="none"/>
          <rect x="2" y="9" width="7" height="5" stroke="currentColor" strokeWidth="1.5" fill="none"/>
          <rect x="11" y="9" width="7" height="5" stroke="currentColor" strokeWidth="1.5" fill="none"/>
        </svg>
        <span>PIC Tracker</span>
      </button>

      {/* Bench Table - Hidden for now */}
      {/* <button
        className={`view-toggle-btn ${currentView === 'bench-table' ? 'active' : ''}`}
        onClick={() => onViewChange('bench-table')}
        title="Bench Table View"
      >
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
          <rect x="2" y="3" width="5" height="3" fill="currentColor"/>
          <rect x="8" y="3" width="5" height="3" fill="currentColor"/>
          <rect x="14" y="3" width="4" height="3" fill="currentColor"/>
          <rect x="2" y="8" width="5" height="3" fill="currentColor"/>
          <rect x="8" y="8" width="5" height="3" fill="currentColor"/>
          <rect x="14" y="8" width="4" height="3" fill="currentColor"/>
          <rect x="2" y="13" width="5" height="3" fill="currentColor"/>
          <rect x="8" y="13" width="5" height="3" fill="currentColor"/>
          <rect x="14" y="13" width="4" height="3" fill="currentColor"/>
        </svg>
        <span>Bench Table</span>
      </button> */}

      {/* Bench Kanban - Hidden for now */}
      {/* <button
        className={`view-toggle-btn ${currentView === 'bench-kanban' ? 'active' : ''}`}
        onClick={() => onViewChange('bench-kanban')}
        title="Bench Kanban View"
      >
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
          <rect x="2" y="2" width="5" height="16" rx="1" stroke="currentColor" strokeWidth="1.5" fill="none"/>
          <rect x="3" y="5" width="3" height="2" fill="currentColor"/>
          <rect x="3" y="8" width="3" height="2" fill="currentColor"/>

          <rect x="8" y="2" width="5" height="16" rx="1" stroke="currentColor" strokeWidth="1.5" fill="none"/>
          <rect x="9" y="5" width="3" height="2" fill="currentColor"/>
          <rect x="9" y="8" width="3" height="2" fill="currentColor"/>
          <rect x="9" y="11" width="3" height="2" fill="currentColor"/>

          <rect x="14" y="2" width="5" height="16" rx="1" stroke="currentColor" strokeWidth="1.5" fill="none"/>
          <rect x="15" y="5" width="3" height="2" fill="currentColor"/>
        </svg>
        <span>Bench Kanban</span>
      </button> */}
    </div>
  );
};

export default ViewToggle;